export default "__VITE_ASSET__947c6f3b__"